<!--
数值范围输入框
-->
<template>
  <div class="lc-number-range">
    <!-- 展示的值 -->
    <el-input
      :value="numberRangeText"
      :placeholder="numberPlaceholder"
      :prefix-icon="numberIcon"
      clearable
      @clear="handleClear"
      @click.native="handleNumberRangeClick"
    ></el-input>

    <!-- 输入弹窗 -->
    <div v-show="editing" class="input-form">
      <el-input ref="beginNumberRef" v-model="beginNumber" style="width: 80px" placeholder="0" @keyup.enter.native="handleConfirm"></el-input>
      ~
      <el-input v-model="endNumber" style="width: 90px" placeholder="100" @keyup.enter.native="handleConfirm"></el-input>

      <!-- <el-divider class="divider" /> -->

      <el-button-group class="m-l-5 pull-lefft">
        <el-button type="primary" @click="handleConfirm">{{ $t('common.btn.confirm') }}</el-button>
        <el-button type="danger" @click="() => (editing = false)">{{ $t('common.btn.cancel') }}</el-button>
      </el-button-group>
    </div>
  </div>
</template>

<script>
import paramUtil from '@/utils/param_util.js'

// 数值类型
const Money = 'money'

export default {
  name: 'LcNumberRange',
  props: {
    // 绑定的值
    value: {
      type: Array,
      default: () => [null, null]
    },
    // 数值类型，支持: [空]/money/积分等，不同类型会有不同的单位与符号
    numberType: {
      type: String,
      default: ''
    },
    /* 单位，如：元/kW/V
     * 如果设置了上面的 numberType，unit 则不需要设置
     */
    unit: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editing: false, // 编辑中
      triggerByClear: false,
      beginNumber: null,
      endNumber: null,
      numberRange: [null, null],
      numberRangeText: null
    }
  },
  computed: {
    // 数值类型的单位，如：元
    numberUnit() {
      switch (this.numberType) {
        case Money:
          return this.$t('common.unit.yuan')
        default:
          return ''
      }
    },
    // 数值类型的图标
    numberIcon() {
      switch (this.numberType) {
        case Money:
          return 'el-icon-coin'
        default:
          return ''
      }
    },
    // 数值类型的图标
    numberPlaceholder() {
      switch (this.numberType) {
        case Money:
          return `0 ~ 1000 ${this.numberUnit}`
        default:
          return `0 ~ 1000 ${this.unit}`
      }
    }
  },
  watch: {
    // 值改变
    value() {
      this.setNumberRangeWithModel(this.value)
    }
  },
  created() {
    this.setNumberRangeWithModel(this.value)
  },
  methods: {
    emitInputEvent() {
      this.$emit('input', this.numberRange)
    },
    /**
     * 确认输入内容
     * 同步到显示框
     */
    handleConfirm() {
      // 监听数组时不能通过下标修改数组，使用splice等修改原数组的方法修改
      if (!this.isEmptyObject(this.beginNumber) && !isNaN(this.beginNumber)) this.numberRange.splice(0, 1, Number(this.beginNumber))
      if (!this.isEmptyObject(this.endNumber) && !isNaN(this.endNumber)) this.numberRange.splice(1, 1, Number(this.endNumber))

      if (typeof this.numberRange[0] === 'number' && typeof this.numberRange[1] === 'number' && this.numberRange[0] > this.numberRange[1])
        this.numberRange.reverse()
      this.numberRangeText = paramUtil.parseRange2ApiParam(this.numberRange)

      this.emitInputEvent() // 值更新

      this.editing = false // 关闭只读模式
    },
    /**
     * 清空输入的值
     */
    handleClear() {
      this.triggerByClear = true
      this.numberRange = [null, null]
      this.numberRangeText = paramUtil.parseRange2ApiParam(this.numberRange)
      this.emitInputEvent() // 值更新

      this.editing = false // 保持只读模式

      // 延迟重置，为了解决与 click 事件的冲突
      setTimeout(() => {
        this.triggerByClear = false
      }, 1)
    },
    /**
     * 点击范围框
     * 1. 显示输入框
     * 2. 聚焦开始数值的输入框
     * 3. 初始化值
     */
    handleNumberRangeClick() {
      if (this.triggerByClear) return // 忽略清空按钮触发的

      this.editing = true

      // 初始化值
      this.beginNumber = this.numberRange[0]
      this.endNumber = this.numberRange[1]

      // 聚焦
      setTimeout(() => {
        this.$refs.beginNumberRef.focus()
      }, 1)
    },
    /**
     * 根据 v-model 的值更新
     *
     * @param {Array} modelValue 的值
     */
    setNumberRangeWithModel(modelValue) {
      if (this.isEmptyObject(modelValue)) {
        this.numberRange[0] = null
        this.numberRange[1] = null
      } else {
        this.numberRange[0] = modelValue[0]
        this.numberRange[1] = modelValue[1]
      }

      this.numberRangeText = paramUtil.parseRange2ApiParam(this.numberRange)
    }
  }
}
</script>

<style lang="scss" scoped>
.lc-number-range {
  position: relative;
  width: 200px;

  .input-form {
    width: 320px;
    background-color: rgb(250, 250, 250);
    padding: 5px;
    border: 1px solid #e4e7ed;
    // position: fixed;
    // margin-top: -32px;
    position: absolute;
    margin-top: -32px;
    z-index: 1000;

    .divider {
      margin: 10px 0px;
    }
  }
}
</style>
